import React from 'react'
import {Card, CardHeader, Col, FormGroup, Input, Modal, Nav, Table,} from "reactstrap";
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import constants from "../../shared/constants";
import dateHelpers from "../../helpers/DateHelper";
import TicketReport from "./TicketReport";
import ErrorModal from "../Alerts/ErrorModal";
import TicketApiService from "../../api/ticket-api-service";
import businessHelper from "../../helpers/BusinessHelper";
import CheckBoxList from "../Tables/CheckBoxList";
import TicketTypeApiService from "../../api/tt-api-service";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import ClassReport from "./ClassReport";
import ClassApiService from "../../api/classes-api-service";
import ResourceApiService from "../../api/resource-api-service";
import DayOverview from "./DayOverview";
import reportApiService from "../../api/report-api-service";
import IncomeReport from "./IncomeReport";
import lsHelpers from "../../helpers/LsHelper";
import Badge from "reactstrap/es/Badge";
import Label from "reactstrap/es/Label";
import StudentReport from "./StudentReport";
import numberHelpers from "../../helpers/NumberHelper";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const propTypes = {};

export default class Report extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: this.props.type,
            isLoading: false,
            period: this.setPeriod(),
            ticketTypes: null,
            teachers: null,
            classTypes: null,
            locales: this.props.locales,
            rooms: null,
            filters: {
                ticketType: null,
                paymentMethods: null,
                teachers: null,
                rooms: null,
                classTypes: null,
            },
            showFilters: false,
            ticketData: null,
            incomeData: null,
            classData: null,
            dayData: null,
            classDataRaw: null, //stores raw data from  server before filtering
            ticketCount: 0,
            incomeCount: 0,
            ticketPrice: 0,
            incomePrice: 0,
            requestByExpires: false,
            showSearchButton: false,
            validation: {
                start: true,
                end: true
            },
        };

    }

    toggleFilters() {
        this.setState({showFilters: !this.state.showFilters})
    }

    componentDidMount() {
        reportApiService.ahoy("report_view", {report_name: this.state.type})
        this.getData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.type !== this.state.type || prevState.filters !== this.state.filters || prevState.period !== this.state.period) {
            this.handleValidation();
            this.setState({showSearchButton: true})
            lsHelpers.setReportFilters(this.state.filters);
        }

        if (prevState.requestByExpires !== this.state.requestByExpires) {
            this.getData()
        }

        if (prevState.rangeType != this.state.rangeType) {
            this.getStudentsWithUnpaidClasses()
        }

        lsHelpers.setReportDateStart(this.state.period.start);
        lsHelpers.setReportDateEnd(this.state.period.end);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.type !== this.state.type) {
            this.setState({type: nextProps.type})
        }
    }

    componentWillUnmount() {
        lsHelpers.setReportFilters(null)
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-start":
                this.setState(prevState => ({
                    period: {
                        ...prevState.period,
                        start: newValue
                    }
                }));
                break;
            case "input-end":
                this.setState(prevState => ({
                    period: {
                        ...prevState.period,
                        end: newValue
                    }
                }));
                break;
            default:
                return null;
        }
    }

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showFilters &&
                    this.renderFilterModal()
                    }

                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Col lg="12">
                        <Card className="bg-default shadow">
                            {this.showControls() &&
                            <>
                                <Row style={{marginLeft: 4}}>
                                    <Col lg="4">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-start"
                                            >
                                                {this.showEndDate() ? commonStrings.from : ""}
                                            </label>
                                            <Input
                                                className={this.state.validation.start === true ? "form-control-alternative" : "is-invalid"}
                                                onChange={this.handleChange.bind(this)}
                                                defaultValue={this.state.period.start}
                                                id="input-start"
                                                type="date"
                                            />
                                        </FormGroup>
                                    </Col>
                                    {this.showEndDate() &&
                                    <Col lg="4">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-end"
                                            >
                                                {commonStrings.until}
                                            </label>

                                            <Input
                                                className={this.state.validation.end === true ? "form-control-alternative" : "is-invalid"}
                                                onChange={this.handleChange.bind(this)}
                                                defaultValue={this.state.period.end}
                                                id="input-end"
                                                type="date"
                                            />
                                        </FormGroup>
                                    </Col>
                                    }
                                    <Col lg="auto" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                        <Row>
                                            {this.showFilterButton() &&
                                            <Col>
                                                <Button

                                                    color={this.filtersAreEmpty() ? "info" : "danger"}
                                                    onClick={this.prepareAndShowFilters.bind(this)}
                                                    size="lg"
                                                >
                                                    {reportStrings.filter}
                                                </Button>
                                            </Col>
                                            }
                                            {this.state.showSearchButton &&
                                            <Col>
                                                <Button

                                                    color={"success"}
                                                    onClick={this.getData.bind(this)}
                                                    size="lg"
                                                >
                                                    {commonStrings.search}
                                                </Button>
                                            </Col>
                                            }
                                        </Row>
                                    </Col>
                                </Row>

                                {this.showByExpiringControls() &&
                                <Row>
                                    <FormGroup>
                                        <div className="col text-right ml-3"
                                             data-tip={resourceStrings.public_profile.public_switch_expl}
                                             data-type="error"
                                             style={{
                                                 display: "flex",
                                                 alignItems: "center"
                                             }}
                                        >
                                            <Label
                                                className={this.state.requestByExpires === false ? "text-white mr-2" : "mr-2"}
                                            >{resourceStrings.purchased}</Label>
                                            <label className="custom-toggle">
                                                <input type="checkbox"
                                                       color="success"
                                                       onChange={this.toggleByExpires.bind(this)}
                                                    //checked={this.state.pp.public && this.readyToGoPublic()}
                                                       id="public-slider"/>
                                                <span className="custom-toggle-slider rounded-circle"/>
                                            </label>
                                            <Label
                                                className={this.state.requestByExpires === true ? "text-white ml-2" : "ml-2"}>{resourceStrings.valid_until}</Label>
                                        </div>
                                    </FormGroup>
                                </Row>
                                }
                            </>
                            }
                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent">
                                    <Row>
                                        <h2 className="text-white mb-0">{this.reportName()}</h2>
                                    </Row>
                                    <Row>
                                        <h5 className="text-warning mb-0">{this.reportStats()}</h5>
                                    </Row>
                                </CardHeader>
                                {this.renderReport()}
                            </Card>
                        </Card>
                    </Col>
                </>
            </LoadingOverlay>
        )
    }

    toggleByExpires() {
        localStorage.expiration_is_on = !this.state.requestByExpires
        this.setState({requestByExpires: !this.state.requestByExpires})
    }

    showByExpiringControls() {
        return this.state.type === constants.reports.ticketReport
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    reportName() {
        switch (this.state.type) {
            case constants.reports.ticketReport:
                return reportStrings.ticket_report;
            case constants.reports.incomeReport:
                return reportStrings.income_report;
            case constants.reports.attendanceReport:
                return reportStrings.attendance_report;
            case constants.reports.dayReport:
                return reportStrings.day_overview;
            case constants.reports.monthReport:
                return reportStrings.period_overview;
            case constants.reports.expiringTickets:
                return reportStrings.expiring_tickets_report;
            case constants.reports.renewableTicketReport:
                return resourceStrings.subscriptions.subscriptions;
            case constants.reports.studentWithUnpaidClassesReport:
                return reportStrings.unpaid_report;
            default:
                return ""
        }
    }

    reportStats() {
        switch (this.state.type) {
            case constants.reports.ticketReport:
                return this.state.ticketCount + " " + resourceStrings.tickets + `, ${businessHelper.currency()} ${numberHelpers.formatPrice(this.state.ticketPrice)}`;
            case constants.reports.incomeReport:
                return this.state.ticketCount + " " + resourceStrings.tickets + `, ${businessHelper.currency()} ${numberHelpers.formatPrice(this.state.ticketPrice)}`
                    + " | " + this.state.incomeCount + " " + resourceStrings.incomes + `, ${businessHelper.currency()} ${numberHelpers.formatPrice(this.state.incomePrice)}`;
            case constants.reports.expiringTickets:
                return this.state.ticketCount + " " + resourceStrings.tickets + `, ${businessHelper.currency()} ${numberHelpers.formatPrice(this.state.ticketPrice)}`;
            case constants.reports.attendanceReport:
                return (this.state.classData || []).length + " " + resourceStrings.classes;
            default:
                return ""
        }
    }

    setPeriod() {
        if (this.props.period) {
            return this.props.period
        } else switch (this.props.type) {
            case constants.reports.ticketReport:
                return {
                    start: dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()),
                    end: dateHelpers.databaseDate(dateHelpers.lastDayOfMonth())
                };
            case constants.reports.incomeReport:
                return {
                    start: dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()),
                    end: dateHelpers.databaseDate(dateHelpers.lastDayOfMonth())
                };
            case constants.reports.attendanceReport:
                return {
                    start: dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()),
                    end: dateHelpers.databaseDate(dateHelpers.lastDayOfMonth())
                };
            case constants.reports.dayReport:
                return {
                    start: dateHelpers.databaseDate(new Date()),
                    end: dateHelpers.databaseDate(new Date()),
                };
            case constants.reports.monthReport:
                return {
                    start: dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()),
                    end: dateHelpers.databaseDate(dateHelpers.lastDayOfMonth())
                };
            default:
                return {
                    start: dateHelpers.databaseDate(new Date()),
                    end: dateHelpers.databaseDate(new Date())
                };
        }
    }

    getData() {
        switch (this.state.type) {
            case constants.reports.ticketReport:
                if (this.datesAreValid()) this.getTicketData();
                break;
            case constants.reports.renewableTicketReport:
                this.getRenewableTicketData();
                break;
            case constants.reports.incomeReport:
                if (this.datesAreValid()) this.getIncomeData();
                break;
            case constants.reports.expiringTickets:
                this.getExpiringTicketData();
                break;
            case constants.reports.attendanceReport:
                if (this.datesAreValid()) this.getClassData();
                break;
            case constants.reports.dayReport:
                this.getDayData();
                break;
            case constants.reports.monthReport:
                this.getDayData("m");
                break;
            case constants.reports.studentWithUnpaidClassesReport:
                this.getStudentsWithUnpaidClasses();
                break;
            default:
                return null
        }
    }

    getStudentsWithUnpaidClasses() {
        this.setState({isLoading: true})
        const rangeType = this.state.rangeType;

        reportApiService.studentWithUnpaidClasses(rangeType)
            .then(result => {
                const processedResult = this.mapStudentData(result.data);
                this.setState({studentData: processedResult, isLoading: false, showSearchButton: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    getDayData(type = "d", allLocales = false) {
        this.setState({isLoading: true, dayData: null});

        reportApiService.periodData(this.state.period.start, type === "d" ? this.state.period.start : this.state.period.end, allLocales)
            .then(res => {
                this.setState({dayData: res, isLoading: false, showSearchButton: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    mapStudentData(data) {
        return data.map((record) => {return {student: JSON.parse(record[0]), yclasses: record[1]}})
    }

    renderReport() {
        switch (this.state.type) {
            case constants.reports.ticketReport:
                if (this.state.ticketData !== null)
                    return <TicketReport
                        data={this.state.ticketData}
                        closeReport={this.closeReport}
                    />;
                else break;
            case constants.reports.renewableTicketReport:
                if (this.state.ticketData != null)
                    return <TicketReport
                        data={this.state.ticketData}
                        type={constants.reports.renewableTicketReport}
                        closeReport={this.closeReport}
                    />;
                else break;
            case constants.reports.expiringTickets:
                if (this.state.ticketData !== null)
                    return <TicketReport
                        data={this.state.ticketData}
                        closeReport={this.closeReport}
                    />;
                else break;
            case constants.reports.incomeReport:
                if (this.state.ticketData !== null && this.state.incomeData !== null)
                    return <Row>
                        <TicketReport
                            data={this.state.ticketData}
                            closeReport={this.closeReport}
                        />
                        <IncomeReport style={{marginTop: 2}}
                                      data={this.state.incomeData}
                                      closeReport={this.closeReport}
                        />
                    </Row>;
                else
                    break;
            case constants.reports.studentWithUnpaidClassesReport:
                if (this.state.studentData)
                    return <Row>
                        <StudentReport
                            data={this.state.studentData}
                            closeReport={this.closeReport}
                            rangeType={this.state.rangeType}
                            onRangeUpdated={this.onRangeUpdated.bind(this)}
                        />
                    </Row>;
                else
                    break;
            case constants.reports.attendanceReport:
                if (this.state.classData !== null)
                    return <ClassReport
                        data={this.state.classData}
                        closeReport={this.closeReport}
                    />;
                else break;
            case constants.reports.dayReport:
                if (this.state.dayData !== null)
                    return <DayOverview
                        reportType="d"
                        data={this.state.dayData}
                        closeReport={this.closeReport}
                        period={this.state.period}
                        redirectToReport={this.props.redirectToReport}
                        handleNetworkError={this.handleNetworkError}
                        getData={this.getDayData.bind(this)}
                        locales={this.state.locales}
                        toggleAllLocales={this.toggleAllLocales.bind(this)}
                        allLocales={this.state.allLocales}
                    />;
                else break;
            case constants.reports.monthReport:
                if (this.state.dayData !== null)
                    return <DayOverview
                        reportType="m"
                        data={this.state.dayData}
                        closeReport={this.closeReport}
                        period={this.state.period}
                        redirectToReport={this.props.redirectToReport}
                        handleNetworkError={this.handleNetworkError}
                        getData={this.getDayData.bind(this)}
                        locales={this.state.locales}
                        toggleAllLocales={this.toggleAllLocales.bind(this)}
                        allLocales={this.state.allLocales}
                    />;
                else break;
            default:
                return null
        }
    }

    onRangeUpdated = (event, newRangeType) => {
        event.preventDefault();
        this.setState({rangeType: newRangeType})
    }

    toggleAllLocales(reportType, newState) {
        this.setState({allLocales: newState})
        this.getDayData(reportType, newState)
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    getTicketData() {
        this.setState({isLoading: true, ticketData: null});

        const data = this.prepareTicketRequestData();
        TicketApiService.ticketReport(data)
            .then(res => {
                const price = res.map(it => parseFloat(it.price)).reduce((a, b) => a + b, 0);
                this.setState({
                    ticketData: res,
                    isLoading: false,
                    ticketCount: res.length,
                    ticketPrice: price,
                    showSearchButton: false
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    getRenewableTicketData() {
        this.setState({isLoading: true, ticketData: null});

        TicketApiService.renewableTicketReport()
            .then(res => {
                const price = res.map(it => parseFloat(it.price)).reduce((a, b) => a + b, 0);
                this.setState({
                    ticketData: res,
                    isLoading: false,
                    ticketCount: res.length,
                    ticketPrice: price,
                    showSearchButton: false
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    getExpiringTicketData() {
        this.setState({isLoading: true, ticketData: null});

        TicketApiService.expiringTicketReport()
            .then(res => {
                const price = res.map(it => parseFloat(it.price)).reduce((a, b) => a + b, 0);
                this.setState({
                    ticketData: res,
                    isLoading: false,
                    ticketCount: res.length,
                    ticketPrice: price,
                    showSearchButton: false
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleValidation() {
        this.validateDates();
    }

    getClassData() {
        this.setState({isLoading: true, classData: null});

        ClassApiService.yclasses(this.state.period)
            .then(res => {
                this.setState({
                    classDataRaw: res,
                    classData: this.filteredClasses(res),
                    isLoading: false,
                    showSearchButton: false
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    validateDates() {
        const start = new Date(this.state.period.start);
        const end = new Date(this.state.period.end);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: start <= end,
                    end: start <= end,
                }
            }));
        } else {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: dateHelpers.isValidDate(start),
                    end: dateHelpers.isValidDate(end),
                }
            }));
        }
    }

    datesAreValid() {
        const start = new Date(this.state.period.start);
        const end = new Date(this.state.period.end);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            return start <= end
        } else {
            return dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)
        }
    }

    prepareTicketRequestData() {
        let requestData = `?date_start=${this.state.period.start}&date_end=${this.state.period.end}`;

        if (this.state.filters) {
            if (this.state.filters.ticketTypes && this.state.filters.ticketTypes.length > 0) {
                const names = this.state.filters.ticketTypes.map(it => it.name).join(",");
                requestData = requestData.concat(`&names=${names}`)
            }
            if (this.state.filters.paymentMethods && this.state.filters.paymentMethods.length > 0) {
                const pt = this.state.filters.paymentMethods.map(it => it.value).join(",");
                requestData = requestData.concat(`&pt=${pt}`)
            }
            if (this.state.requestByExpires === true) {
                requestData = requestData.concat(`&exp=true`)
            }
        }

        return requestData
    }

    renderFilterModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showFilters}
                toggle={() => this.toggleFilters("formModal")}
            >
                <div className="modal-body p-0">

                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-gradient-secondary pb-2">
                            <div className="text-white text-center mt-2 mb-3">
                                <h4>{reportStrings.filter}</h4>
                            </div>
                        </CardHeader>
                        {this.props.type === constants.reports.ticketReport &&
                        this.renderTicketFilters()
                        }
                        {this.props.type === constants.reports.attendanceReport &&
                        this.renderClassFilters()
                        }
                    </Card>
                </div>
            </Modal>
        )
    }

    renderTTTable() {
        const selected = (this.state.filters.ticketTypes) ? this.state.filters.ticketTypes.map(it => it.id) : [];
        return (this.state.ticketTypes).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleTTSelected.bind(this)}/>
            )
        })
    };

    renderTeacherTable() {
        const selected = (this.state.filters.teachers) ? this.state.filters.teachers.map(it => it.id) : [];
        return (this.state.teachers).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleTeacherSelected.bind(this)}/>
            )
        })
    };

    renderRoomTable() {
        const selected = (this.state.filters.rooms) ? this.state.filters.rooms.map(it => it.id) : [];
        return (this.state.rooms).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleRoomSelected.bind(this)}/>
            )
        })
    };

    renderClassTypeTable() {
        const selected = (this.state.filters.classTypes) ? this.state.filters.classTypes.map(it => it.id) : [];
        return (this.state.classTypes).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleClassTypeSelected.bind(this)}/>
            )
        })
    };

    handleClassTypeSelected(checked, id) {
        const tt = this.state.classTypes.find(it => it.id === id);
        const selected = ((this.state.filters.classTypes) ? this.state.filters.classTypes : []);
        const selectedIds = ((this.state.filters.classTypes) ? this.state.filters.classTypes : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    classTypes: selected
                }
            }));

        }
    }

    handleTeacherSelected(checked, id) {
        const tt = this.state.teachers.find(it => it.id === id);
        const selected = ((this.state.filters.teachers) ? this.state.filters.teachers : []);
        const selectedIds = ((this.state.filters.teachers) ? this.state.filters.teachers : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    teachers: selected
                }
            }));

        }
    }

    handleRoomSelected(checked, id) {
        const tt = this.state.rooms.find(it => it.id === id);
        const selected = ((this.state.filters.rooms) ? this.state.filters.rooms : []);
        const selectedIds = ((this.state.filters.rooms) ? this.state.filters.rooms : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    rooms: selected
                }
            }));
        }
    }

    handleTTSelected(checked, id) {
        const tt = this.state.ticketTypes.find(it => it.id === id);
        const selected = ((this.state.filters.ticketTypes) ? this.state.filters.ticketTypes : []);
        const selectedIds = ((this.state.filters.ticketTypes) ? this.state.filters.ticketTypes : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    ticketTypes: selected
                }
            }));
        }
    }

    prepareAndShowFilters() {
        switch (this.state.type) {
            case constants.reports.ticketReport:
                if (this.state.ticketTypes !== null) {
                    this.toggleFilters();
                    break;
                } else {
                    this.getTicketTypes();
                    break;
                }
            case constants.reports.attendanceReport:
                if (this.state.teachers !== null && this.state.rooms !== null) {
                    this.toggleFilters();
                    break;
                } else {
                    this.getTeachersAndRooms();
                    break;
                }
            default:
                return null
        }
    }

    getTeachersAndRooms() {
        this.setState({isLoading: true});

        ResourceApiService.teachersRoomsClassTypes()
            .then(res => {
                this.setState({
                    isLoading: false,
                    teachers: res[0] || [],
                    rooms: res[1] || [],
                    classTypes: res[2] || [],
                });

                this.prepareAndShowFilters()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getTicketTypes() {
        this.setState({isLoading: true});

        TicketTypeApiService.index()
            .then(res => {
                this.setState({
                    ticketTypes: res,
                    isLoading: false
                });

                this.prepareAndShowFilters()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    renderPTTable() {
        const selected = (this.state.filters.paymentMethods) ? this.state.filters.paymentMethods.map(it => it.value) : [];
        return (paymentTypeHelpers.paymentTypes()).map((pm, index) => {

            return (
                <CheckBoxList item={{id: pm.value, label: pm.label}} key={pm.value}
                              selected={selected.includes(pm.value)}
                              handleChange={this.handlePMSelected.bind(this)}/>
            )
        })
    }

    handlePMSelected(checked, value) {
        const pm = paymentTypeHelpers.paymentTypes().find(it => it.value === value);
        const selected = ((this.state.filters.paymentMethods) ? this.state.filters.paymentMethods : []);
        const selectedValues = ((this.state.filters.paymentMethods) ? this.state.filters.paymentMethods : []).map(it => it.value);

        if (pm) {
            if (checked) {
                if (!selectedValues.includes(pm.value)) {
                    selected.push(pm);
                }
            } else {
                if (selectedValues.includes(pm.value)) {
                    const index = selectedValues.indexOf(pm.value);
                    if (index !== -1) selected.splice(index, 1);
                }
            }

            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    paymentMethods: selected
                }
            }));
        }
    }

    filtersAreEmpty() {
        return (!this.state.filters.ticketTypes || this.state.filters.ticketTypes.length === 0)
            && (!this.state.filters.paymentMethods || this.state.filters.paymentMethods.length === 0)
            && (!this.state.filters.teachers || this.state.filters.teachers.length === 0)
            && (!this.state.filters.rooms || this.state.filters.rooms.length === 0)
    }

    filteredClasses(allClasses) {
        let classes = allClasses || [];

        if (this.state.filters.teachers && this.state.filters.teachers.length > 0) {
            classes = classes.filter(it => this.state.filters.teachers.map(t => t.name).includes(it.teacher || ""))
        }

        if (this.state.filters.classTypes && this.state.filters.classTypes.length > 0) {
            classes = classes.filter(it => this.state.filters.classTypes.map(t => t.name).includes(it.name))
        }

        if (this.state.filters.rooms && this.state.filters.rooms.length > 0) {
            classes = classes.filter(it => this.state.filters.rooms.map(t => t.name).includes(it.room))
        }

        return classes
    }

    renderTicketFilters() {
        return <Row>
            <Col lg="6">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.ticket_types}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderTTTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
            <Col lg="6">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.payment_methods.payment_methods}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderPTTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
        </Row>
    }

    renderClassFilters() {
        return <Row>
            <Col lg="4">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.teachers}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderTeacherTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
            <Col lg="4">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.class_types}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderClassTypeTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
            <Col lg="4">
                <Card style={{margin: 10}}>
                    <Table
                        className="align-items-center table-light table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">{resourceStrings.rooms}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderRoomTable()}
                        </tbody>
                    </Table>
                </Card>
            </Col>
        </Row>
    }

    showEndDate() {
        switch (this.state.type) {
            case constants.reports.ticketReport:
                return true;
            case constants.reports.attendanceReport:
                return true;
            case constants.reports.dayReport:
                return false;
            case constants.reports.monthReport:
                return true;
            default:
                return true
        }
    }

    showFilterButton() {
        switch (this.state.type) {
            case constants.reports.ticketReport:
                return true;
            case constants.reports.attendanceReport:
                return true;
            case constants.reports.dayReport:
                return false;
            case constants.reports.monthReport:
                return false;
            default:
                return true
        }
    }

    showControls() {
        return this.state.type !== constants.reports.expiringTickets && this.state.type !== constants.reports.renewableTicketReport && this.state.type !== constants.reports.studentWithUnpaidClassesReport
    }

    getIncomeData() {
        this.setState({isLoading: true, ticketData: null});

        reportApiService.ticketsAndIncomes(this.state.period)
            .then(res => {
                const ticketPrice = res[0].map(it => parseFloat(it.price)).reduce((a, b) => a + b, 0);
                const incomePrice = res[1].map(it => parseFloat(it.price) * it.qty).reduce((a, b) => a + b, 0);
                this.setState({
                    ticketData: res[0],
                    incomeData: res[1],
                    isLoading: false,
                    ticketCount: res[0].length,
                    incomeCount: res[1].length,
                    ticketPrice: ticketPrice,
                    incomePrice: incomePrice,
                    showSearchButton: false
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }
}

Report.propTypes = propTypes;